// @flow
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  reduxForm,
  formValueSelector,
  change,
  reset,
} from 'redux-form';
import i18n from 'i18n-js';
import { Col } from 'react-flexbox-grid';

import Button from '../Button/index';
import InlineError from '../InlineError/index';

import styles from './createUserForm.css';
import * as selectors from '../../reducers/index';
import * as closeableActions from '../../actions/closeable';
import * as userActions from '../../actions/users';
import {
  DRIVER_RESULT_TYPE,
  PARENT_RESULT_TYPE,
  MONITOR_RESULT_TYPE,
  STUDENT_RESULT_TYPE,
} from '../UserSearchResult/types';
import {
  onSubmit,
  updateUser,
  /* removeUser, */
  validate,
} from './utils';
import PopupFooter from '../PopupFooter';
import type { PARENT_TYPE } from '../../types/parents';
import { Cancel, CreateButton } from '../CommonTexts';
import StudentForm from './StudentForm';
import ParentForm from './ParentForm';
import MonitorForm from './MonitorForm';
import DriverForm from './DriverForm';


type CreateUserFormPropTypes = {
  creatingError: Object,
  isCreating: boolean,
  profileType: Object,
  closePopup: Function,
  addStudentContact: Function,
  updateStudentContact: Function,
  removeStudentContact: Function,
  handleSubmit: Function,
  parents: Array<PARENT_TYPE>,
  userType: string,
  changeUserType: Function,
  close: Function,
};

const CREATE_USER_FORM_ID = 'createUser';
let CreateUserForm = ({
  creatingError,
  handleSubmit,
  /* profileType = {}, */
  isCreating = false,
  addStudentContact,
  updateStudentContact,
  removeStudentContact,
  userType,
  changeUserType,
  parents,
  /* close, */
}: CreateUserFormPropTypes) => {
  useEffect(() => {
    changeUserType(userType);
  }, [userType]);

  const calculateRender = () => {
    const studentForm = (
      <StudentForm
        onAddContact={data => addStudentContact(data, parents)}
        onEditContact={data => updateStudentContact(data, parents)}
        onRemoveContact={contactId => removeStudentContact(contactId, parents)}
      />
    );
    switch (userType) {
      case DRIVER_RESULT_TYPE:
        return <DriverForm />;
      case PARENT_RESULT_TYPE:
        return <ParentForm />;
      case MONITOR_RESULT_TYPE:
        return <MonitorForm />;
      case STUDENT_RESULT_TYPE:
        return studentForm;
      default:
        return studentForm;
    }
  };

  return (
    <form className={styles.form} id="createUser" onSubmit={handleSubmit}>
      {calculateRender()}
      <br />
      <PopupFooter align="center">
        <div className={styles.footer}>
          {/* <Button
            title={Cancel()}
            onClick={() => close('createSingleUser')}
            tint="gray"
            isOutlined
            clearMargins
            type="button"
          /> */}
          <Col xs={8}>
            <Button
              size="medium"
              title={CreateButton(i18n.t('common.user', { count: 1 }))}
              className={styles.approveButton}
              type="submit"
              isLoading={isCreating}
              clearMargins
              isFullWidth
            />
          </Col>
        </div>
      </PopupFooter>
      <div className={styles.footer}>
        <InlineError objectError={creatingError} />
      </div>
    </form>
  );
};

CreateUserForm = reduxForm({
  form: CREATE_USER_FORM_ID,
  onSubmit,
  validate,
})(CreateUserForm);

CreateUserForm = connect(
  (state, { userType }) => {
    const fvs = formValueSelector(CREATE_USER_FORM_ID);

    return {
      initialValues: {
        user_profile: userType,
        parents: [],
      },
      creatingError: selectors.getErrorUserCreating(state),
      isCreating: selectors.isCreatingUser(state),
      profileType: fvs(state, 'user_profile'),
      parents: fvs(state, 'parents') || [],
    };
  },
  dispatch => ({
    /* close(id) {
      dispatch(closeableActions.close(id));
      dispatch(userActions.addUserCancel());
    }, */
    addStudentContact(data, parents = []) {
      if (data.fromApi) {
        dispatch(change(CREATE_USER_FORM_ID, 'parents', [...parents, data]));
      } else {
        onSubmit(
          {
            user_profile: 'parent_profile',
            isContact: true,
            ...data,
          },
          dispatch,
          null,
        );
      }
    },
    updateStudentContact(updatedUser: Object) {
      updateUser(
        {
          user_profile: 'parent_profile',
          isContact: true,
          user_id: updatedUser.id,
          profile_id: updatedUser.profile_id,
          ...updatedUser,
        },
        dispatch,
      );
    },
    removeStudentContact(contactId: ID_TYPE, parents: any[]) {
      /* removeUser(contactId, 'parent_profile', dispatch); */

      const newParentsArray = parents.filter(parent => parent.id !== contactId);

      dispatch(change(CREATE_USER_FORM_ID, 'parents', newParentsArray));
    },
    changeUserType(userType: string) {
      dispatch(reset(CREATE_USER_FORM_ID));
      dispatch(change(CREATE_USER_FORM_ID, 'user_profile', userType));
    },
  }),
)(CreateUserForm);

const CreateUser = CreateUserForm;

export default CreateUser;



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUserForm/index.jsx